// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-37f3272e]:export{primaryColor:#ffb81c;secondaryColor:#07a1c1;accentColor:#eb6200}.main-nav-header[data-v-37f3272e]{background:#fff!important}.logo[data-v-37f3272e]{height:60%;width:320px;margin-top:4%;margin-left:11%;position:relative;top:10px}.bottom-bar[data-v-37f3272e]{position:absolute;height:7px;width:100%;background:var(--color-primary);z-index:1;top:120px;left:0;right:0}", ""]);
// Exports
module.exports = exports;
